import type { Column } from '@ps-smart-cp/ppfw-client';
import { DateFormatter } from '@ps-smart-cp/ppfw-client';
import { mstRegistrationFieldConfig } from '../item-config';
import type { MstRegistration } from '../models';

function genMstColumns<T extends MstRegistration>(): Column<T>[] {
  return [
    { displayName: mstRegistrationFieldConfig.code, renderCell: ({ row }) => row.code },
    { displayName: mstRegistrationFieldConfig.name, renderCell: ({ row }) => row.name, width: 250 },
    { displayName: mstRegistrationFieldConfig.mstSpareName01, renderCell: ({ row }) => row.mstSpareName01 },
    { displayName: mstRegistrationFieldConfig.mstSpareName02, renderCell: ({ row }) => row.mstSpareName02 },
    {
      displayName: mstRegistrationFieldConfig.validityStartDate,
      renderCell: ({ row }) => <DateFormatter date={row.validityStartDate} type="ymd" />,
    },
    {
      displayName: mstRegistrationFieldConfig.validityEndDate,
      renderCell: ({ row }) => <DateFormatter date={row.validityEndDate} type="ymd" />,
    },
    { displayName: mstRegistrationFieldConfig.mstNote, renderCell: ({ row }) => row.mstNote },
  ];
}

export { genMstColumns };
